<template>
  <v-app class="trans">
    <v-layout fill-height>
      <v-card class="elevation-0 trans">
        <v-speed-dial top left direction="bottom" transition="slide-x-transition">
          <v-btn slot="activator" color="#FFFFFF44" dark fab>
            <img src="/VantariVR-Logo.svg" width=28 height=28>
          </v-btn>
          <v-btn fab dark small color="pink" @click="showInfoDialog = true">
            <v-icon>info</v-icon>
          </v-btn>
          <v-btn fab dark small color="pink" @click="showGalleryDialog = true">
            <v-icon>photo</v-icon>
          </v-btn>
          <v-btn fab dark small color="pink" @click="showHelpDialog = true">
            <v-icon>help</v-icon>
          </v-btn>
          <v-btn fab dark small color="pink" @click="showContactDialog = true">
            <v-icon>email</v-icon>
          </v-btn>
        </v-speed-dial>
      </v-card>

      <v-spacer></v-spacer>

      <v-card class="elevation-0 trans">
        <v-speed-dial v-if="totalProgress < 99.9" top right direction="bottom" transition="slide-x-reverse-transition">
          <v-progress-circular slot="activator" class="mt-2" size=60 :value="totalProgress" color="grey" >
            {{totalProgress}}
          </v-progress-circular>
        </v-speed-dial>
      </v-card>
    </v-layout>

    <v-dialog v-model="showWelcomeDialog" max-width="400">
      <v-card>
        <v-card-title class="headline mb-0 pb-0">VantariVR</v-card-title>
        <v-card-title class="subheadline mt-0 pt-0 pink--text">Web Delivered Augmented Reality</v-card-title>

        <v-card-text>
          <v-card class="elevation-3 py-2">
            <v-layout row align-center>
              <v-flex xs6>
                <div class="text-xs-right">
                  Make sure you have your <b>Vantari VR Augmented Reality Card</b> ready!
                </div>
              </v-flex>
              <v-flex xs4 offset-xs1>
                <img width="100%" height="100%" src="/Cards/card2.png">
              </v-flex>
            </v-layout>
          </v-card>
        </v-card-text>

        <v-card-text>
          <v-layout row align-center>
            <v-flex xs2>
              <div class="text-xs-center">
                <v-btn color="#FFFFFF44" dark fab class="mx-0"><img src="/VantariVR-Logo.svg" width=28 height=28></v-btn>
              </div>
            </v-flex>
            <v-flex xs9 offset-xs1>
              Click the VantariVR logo at the top-left of screen for help and more information.
            </v-flex>
          </v-layout>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat round @click.native="showWelcomeDialog = false" class="pink--text">Start</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>

      </v-card>
    </v-dialog>

    <v-dialog v-model="showGalleryDialog">
      <v-card>
        <v-card-title class="headline mb-0 pb-0">Gallery</v-card-title>
        <v-card-title class="subheadline mt-0 pt-0 pink--text">Application</v-card-title>

        <v-card-text>
          <v-carousel height="90%">
            <v-carousel-item v-for="(item,i) in photos" :key="i" :src="item.src"></v-carousel-item>
          </v-carousel>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showInfoDialog" max-width="400">
      <v-card>
        <v-card-title class="headline mb-0 pb-0">VantariVR</v-card-title>
        <v-card-title class="subheadline mt-0 pt-0 pink--text">Introducing Augmented Reality</v-card-title>
        <v-card-text>
          Welcome to VantariVR's demonstration of Augmented Reality (AR)!
        </v-card-text>

        <v-card-text>
          AR builds a bridge between real and virtual worlds.  The idea is that computer generated information is able to augment
          or enhance your real-world view by overlaying computer generated images.
        </v-card-text>

        <v-card-text>
          While Pokémon GO may have introduced a lot of
          people to AR, there are compelling applications for AR beyond games.  In Medicine, the opportunities range from patient
          education and medical professional training to AR assisted emergency response and surgery.  VantariVR is active in all
          of these areas and seeks to provide industry leading AR and VR solutions to medical professionals.
        </v-card-text>

        <v-card-text>
          This demonstration acts as an introduction to AR, showing just how accessible the technology is; the demonstration
          is delivered over the Web to your smart phone, tablet or PC with no software installation required.
        </v-card-text>

        <v-card-text>
          The models shown in this application form part of a larger Virtual Reality application developed by VantariVR.
          <a @click="showInfoDialog = false; showContactDialog = true;">Get in touch</a> with us to learn more.
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat round @click.native="showInfoDialog = false" class="pink--text">CLOSE</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showHelpDialog" max-width="400">
      <v-card>
        <v-card-title class="headline mb-0 pb-0">Help!</v-card-title>
        <v-card-title class="subheadline mt-0 pt-0 pink--text">How to use this app</v-card-title>
        <v-card-text>
          Place your VantariVR Augmented Reality card on a flat, level surface under good lighting
          and use your phone or tablet's camera to view the card.  The application will recognise
          the card and augment the camera's view with part of a medical scene.
        </v-card-text>
        <v-card-text>
          There are <i>three cards to collect</i> to complete the scene. Each card contains
          an animated character and other 3D content.
        </v-card-text>
        <v-card-text>
          All three cards are shown below.  Click each card to download a printable image
          of each card to complete your collection.  You can lay out your scene any way you like by
          moving the cards around.  To achieve the intended scene layout, lay the cards out as
          shown in the animation.
        </v-card-text>

        <v-card-text>
          <v-layout column align-center>
            <a ref="card1" href="/Cards/VantariVR-ar-card-1.png" download><div class="card card1"></div></a>
            <a ref="card2" href="/Cards/VantariVR-ar-card-2.png" download><div class="card card2"></div></a>
            <a ref="card3" href="/Cards/VantariVR-ar-card-3.png" download><div class="card card3"></div></a>
          </v-layout>
        </v-card-text>

        <v-card-text>
          This application should work well on most modern Android and iOS devices.  iOS 11 or later
          is required for camera access.  We recommend using Chrome on Android and Safari on iOS.
          If you have problems using this application, please
          <a @click="showHelpDialog = false; showContactDialog = true;">contact us</a>; your feedback would
          be greatly appreciated.
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat round @click.native="showHelpDialog = false" class="pink--text">CLOSE</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showContactDialog" max-width="400">
      <v-card>
        <v-card-title class="headline">Contact</v-card-title>

        <v-layout row>
          <v-spacer></v-spacer>
          <v-list>

            <v-list-tile class="mr-5">
              <v-list-tile-action><v-icon color="pink">open_in_browser</v-icon></v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title><a target="_blank" rel="noopener noreferrer" href="https://www.vantarivr.com/">www.vantarivr.com</a></v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>

            <v-list-tile>
              <v-list-tile-action><v-icon color="pink">mail</v-icon></v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title><a href="mailto:info@vantarivr.com">info@vantarivr.com</a></v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>

            <v-list-tile>
              <v-list-tile-action> <v-icon color="pink">location_on</v-icon> </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>11-31 York St</v-list-tile-title>
                <v-list-tile-title>Sydney NSW 2000</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>

            <v-card-actions class="mt-4">
              <a class="mx-3" href="https://www.facebook.com/VantariVR/" title="Facebook"><svg class="social_icon" role="img" viewBox="0 0 118 228"><path d="M34.8 226.8V123.5H0V83.2h34.8V53.5C34.8 19 55.8.2 86.6.2c14.8 0 27.4 1 31 1.6v36h-21c-16.8 0-20 8-20 19.7v25.7h40l-5.4 40.3H76.5v103.3"/></svg></a>
              <a class="mx-3" href="https://twitter.com/VantariVr" title="Twitter"><svg class="social_icon" role="img" viewBox="0 0 274 223"><path d="M273.4 26.4a110 110 0 0 1-32.2 8.8a56 56 0 0 0 24.6-31a107 107 0 0 1-35.6 13.6A56.1 56.1 0 0 0 134.6 69A159 159 0 0 1 19 10.4a56 56 0 0 0 17.4 74.9a60 60 0 0 1-25.4-7a56 56 0 0 0 45 55.6a60 60 0 0 1-25.4 1a56 56 0 0 0 52.4 39a112 112 0 0 1-83 23a159 159 0 0 0 245.4-141.5a108 108 0 0 0 28-29z"/></svg></a>
              <a class="mx-3" href="https://www.linkedin.com/company/vantarivr/" title="LinkedIn"><svg class="social_icon" role="img" viewBox="0 0 129 129"><path d="M128.8 128.6H102V86.8c0-10 0-22.7-13.7-22.7-14 0-16 11-16 22v42.6H45.6v-86h25.6v11.8h.3c3.6-6.7 12.3-13.8 25.3-13.8 27 0 32 17.8 32 41v47zM15.5 31C7 31 0 24 0 15.5 0 7 7 0 15.5 0S31 7 31 15.5 24 31 15.5 31zM2 128.6H29v-86H2v86z"/></svg></a>
              <v-spacer></v-spacer>
            </v-card-actions>

            <v-divider class="mt-2 mb-0"></v-divider>

            <v-list-tile class="mt-2">
              <v-list-tile-content>
                <v-list-tile-title class="font-weight-thin text-xs-center">© VantariVR Pty Ltd 2018</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>

          </v-list>
          <v-spacer></v-spacer>
        </v-layout>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat round @click.native="showContactDialog = false" class="pink--text">CLOSE</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-app>
</template>

<style scoped>
.trans {
  background-color: transparent !important;
}

.social_icon {
  display: inline-block;
  width: 24px;
  height: 24px;
}

.half_width {
  width: 50%;
}

a {
  color: black;
  text-decoration: underline;
}

a:hover {
  text-decoration: underline;
}

a:active {
  color: black;
}

a:visited {
  color: black;
}

.translucent {
  opacity: 0.5
}

.opaque {
  opacity: 1.0
}

.card {
  height: 110px;
  width: 200px;
  background-size: cover;
  border: 1px solid white;
}

.card1 {
  background-image: url('/Cards/card1.png');
}

.card2 {
  background-image: url('/Cards/card2.png');
}

.card3 {
  background-image: url('/Cards/card3.png');
}

</style>

<script>
import { TimelineLite } from 'gsap'

export default {
  name: 'App',
  mounted () {
    var docs = document.getElementsByTagName('a-asset-item')
    for (let i = 0; i < docs.length; i++) {
      this.monitorProgress(docs[i])
    }

    // Creat a new camera to avoid z-fighting problem.  But we have to do this after the
    // scene is up and running.  It's easy enough to just wait a while...
    // https://github.com/jeromeetienne/AR.js/issues/410
    setTimeout(() => { this.fixupCamera() }, 5000)
    this.fixupCamera()
  },
  data () {
    return {
      showWelcomeDialog: true,
      showInfoDialog: false,
      showGalleryDialog: false,
      showHelpDialog: false,
      showContactDialog: false,

      timeline1: null,
      timeline2: null,
      timeline3: null,

      progress: {},

      photos: [
        { src: '/Photos/Surgeon1.jpg' },
        { src: '/Photos/Patient1.jpg' },
        { src: '/Photos/Anaesthetist1.jpg' },
        { src: '/Photos/Group1.jpg' },
        { src: '/Photos/Group2.jpg' },
        { src: '/Photos/CardLayout.jpg' }
      ]
    }
  },
  computed: {
    totalProgress () {
      var loaded = 0
      var total = 0
      for (var p in this.progress) {
        loaded += this.progress[p].loadedBytes
        total += this.progress[p].totalBytes
      }
      if (total > 0) {
        return Math.round(100*loaded/total)
      }
      return 100
    }
  },
  watch: {
    totalProgress: function (val, oldVal) {
      var docs = document.getElementsByTagName('a-entity')
      for (let i = 0; i < docs.length; i++) {
        docs[i].setAttribute('animation-mixer', { clip: '*' })
      }
      this.fixupCamera()
    },
    showHelpDialog: function (val, oldVal) {
      if (val) {
        console.log('START')
        this.startCardAnimation()
      } else {
        console.log('STOP')
        this.stopCardAnimation()
      }
    }
  },
  methods: {
    monitorProgress (el) {
      el.addEventListener('progress', (e) => {
        // add or update
        var p = this.progress[el.id]
        if (!p) {
          p = {}
          console.log('Added progress')
        }
        p.loadedBytes = e.detail.loadedBytes
        p.totalBytes = e.detail.totalBytes ? e.detail.totalBytes : e.detail.loadedBytes
        p.progress = Math.round(100.0 * e.detail.loadedBytes / e.detail.totalBytes)
        this.$set(this.progress, el.id, Object.assign(p))
        console.log('Updated progress: ' + p.progress)
      })
      el.addEventListener('loaded', (e) => {
      })
    },
    fixupCamera () {
      var d = document.querySelector('a-scene')
      if (!d) return
      var cam = d.sceneEl.camera
      if (cam) {
        // magic 43.1 lifted from the aframe-ar code...
        document.querySelector('a-scene').sceneEl.camera =
          new THREE.PerspectiveCamera(43.1, cam.aspect)
      }
    },
    stopCardAnimation () {
      if (this.timeline1) this.timeline1.kill()
      if (this.timeline2) this.timeline2.kill()
      if (this.timeline3) this.timeline3.kill()

      this.timeline1 = null
      this.timeline2 = null
      this.timeline3 = null
    },
    startCardAnimation () {
      this.stopCardAnimation()

      const { card1, card2, card3 } = this.$refs

      this.timeline1 = new TimelineLite({ onComplete: () => this.timeline1.restart() })
      this.timeline2 = new TimelineLite({ onComplete: () => this.timeline2.restart() })
      this.timeline3 = new TimelineLite({ onComplete: () => this.timeline3.restart() })

      this.timeline1.to(card1, 4, { y: 0 })
      this.timeline2.to(card2, 4, { y: 0 })
      this.timeline3.to(card3, 4, { y: 0 })

      this.timeline1.to(card1, 0.5, { y: -4 })
      this.timeline2.to(card2, 0.5, { y: 0 })
      this.timeline3.to(card3, 0.5, { y: 4 })

      this.timeline1.to(card1, 1.5, { x: 20, y: 50 })
      this.timeline2.to(card2, 0.5, { x: 20, y: 50 })
      this.timeline2.to(card2, 1.0, { x: 20, y: 50 })
      this.timeline3.to(card3, 0.5, { y: 4 })
      this.timeline3.to(card3, 1.5, { x: -74, y: -60, rotation: 90 })

      this.timeline1.to(card1, 0.5, { x: 20, y: 50 })
      this.timeline2.to(card2, 0.5, { x: 20, y: 50 })

      this.timeline1.to(card1, 4, { x: 20, y: 50 })
      this.timeline2.to(card2, 4, { x: 20, y: 50 })
      this.timeline3.to(card3, 4, { x: -74, y: -60, rotation: 90 })

      this.timeline1.to(card1, 0.5, { x: 0, y: 0, rotation: 0 })
      this.timeline2.to(card2, 0.5, { x: 0, y: 0, rotation: 0 })
      this.timeline3.to(card3, 0.5, { x: 0, y: 0, rotation: 0 })
    }
  }
}
</script>
